<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Minutes of Meeting</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Minutes of Meeting</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100  verticaltab--1 ">
  <div class="container">
    <div class="row row-cols-1 justify-content-center">
      <div class="nav flex-column nav-pills vertival-sticky col-lg-2 col" id="v-pills-tab" role="tablist"
        aria-orientation="vertical">

        <button class="nav-link active" id="v-pills-criteria1-tab" data-bs-toggle="pill"
          data-bs-target="#v-pills-criteria1" type="button" role="tab" aria-controls="v-pills-criteria1"
          aria-selected="true">MOM</button>
        <button class="nav-link " id="v-pills-criteria2-tab" data-bs-toggle="pill" data-bs-target="#v-pills-criteria2"
          type="button" role="tab" aria-controls="v-pills-criteria2" aria-selected="true">BOS</button>
        <button class="nav-link " id="v-pills-criteria3-tab" data-bs-toggle="pill" data-bs-target="#v-pills-criteria3"
          type="button" role="tab" aria-controls="v-pills-criteria3" aria-selected="true">IQAC</button>
        <!-- <button class="nav-link " id="v-pills-criteria4-tab" data-bs-toggle="pill" data-bs-target="#v-pills-criteria4" type="button" role="tab" aria-controls="v-pills-criteria4" aria-selected="true">AQAR 2024-25</button> -->

      </div>
      <div class="tab-content col-lg-10 col" id="v-pills-tabContent">
        <!-- criteria 1 -->
        <div class="tab-pane fade show active" id="v-pills-criteria1" role="tabpanel"
          aria-labelledby="v-pills-criteria1-tab">
          <div class="row justify-content-center">
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>10-06-2024 MOM</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/2-501-10-06-2024-MOM.pdf"
                    target="_blank" class="cmn-button">Click Here</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>31-01-2024 MOM</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/2-697-31-01-2024-MOM.pdf"
                    target="_blank" class="cmn-button">Click Here</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>30-01-2024 MOM</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/2-810.1-30-01-2024-MOM.pdf"
                    target="_blank" class="cmn-button">Click Here</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>29-01-2024 MOM</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/2-807.1-29-01-2024-MOM.pdf"
                    target="_blank" class="cmn-button">Click Here</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>22-08-2023 MOM</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/1-22-08-2023-MOM.pdf"
                    target="_blank" class="cmn-button">Click Here</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade show" id="v-pills-criteria2" role="tabpanel" aria-labelledby="v-pills-criteria2-tab">
          <div class="row justify-content-center">
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>BoS B.Sc</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/BOS/BoS-B.Sc.pdf" target="_blank"
                    class="cmn-button">Click Here</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>BBA CA(BoS)</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/BOS/Minutes-of-Meeting_BBA-CA(BoS).pdf"
                    target="_blank" class="cmn-button" target="_blank">Click Here</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>BBA(BoS)</h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/BOS/Minutes-of-Meeting_BBA(BoS).pdf"
                    target="_blank" class="cmn-button" target="_blank">Click Here</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade show" id="v-pills-criteria3" role="tabpanel" aria-labelledby="v-pills-criteria3-tab">
          <div class="row justify-content-center">
            <div class="col-md-4">
              <div class="pdfBox">
                <div class="pdf-icon">
                  <span><i class="fa fa-file-pdf-o"></i></span>
                </div>
                <div class="pdf-content">
                  <h4>10-11-2023 MOM </h4>
                  <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/1.IQAC(1).pdf" target="_blank"
                    class="cmn-button">Click Here</a>
                  <!-- <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/mom/1.IQAC.pdf" target="_blank" class="cmn-button">Click Here</a>               -->
                </div>
              </div>
            </div>
            <!-- <div class="col-md-4">
                  <div class="pdfBox">
                    <div class="pdf-icon">
                        <span><i class="fa fa-file-pdf-o"></i></span>
                    </div>
                    <div class="pdf-content">
                      <h4>AQAR 2021-22</h4>
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-21-22.pdf" target="_blank" class="cmn-button" target="_blank">Click Here</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="pdfBox">
                    <div class="pdf-icon">
                        <span><i class="fa fa-file-pdf-o"></i></span>
                    </div>
                    <div class="pdf-content">
                      <h4>4.1.3</h4>
                      <a href="https://drive.google.com/file/d/1C7FydrKiZeSoCYS73xyBCDMVLyT2kJjw/view?usp=sharing" class="cmn-button" target="_blank">Click Here</a>
                    </div>
                  </div>
                </div> -->
          </div>
        </div>
        <!--  <div class="tab-pane fade show" id="v-pills-criteria4" role="tabpanel" aria-labelledby="v-pills-criteria4-tab">
              <div class="row justify-content-center">
               <div class="col-md-4">
                  <div class="pdfBox">
                    <div class="pdf-icon">
                        <span><i class="fa fa-file-pdf-o"></i></span>
                    </div>
                    <div class="pdf-content">
                      <h4>AQAR 2021-22</h4>
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-21-22.pdf" target="_blank" class="cmn-button" target="_blank">Click Here</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="pdfBox">
                    <div class="pdf-icon">
                        <span><i class="fa fa-file-pdf-o"></i></span>
                    </div>
                    <div class="pdf-content">
                      <h4>4.1.3</h4>
                      <a href="https://drive.google.com/file/d/1C7FydrKiZeSoCYS73xyBCDMVLyT2kJjw/view?usp=sharing" class="cmn-button" target="_blank">Click Here</a>
                    </div>
                  </div>
                </div>
            </div> -->
      </div>
    </div>
  </div>
</section>
